import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import filterStore from '../filter.store';
import Checkbox from '../../../ui/checkbox';
import FloorPopup from '../FloorPopup/FloorPopup';
import { CustomFilterBodyProps } from '../customFilter.type';
import styles from '../checkboxList/styles.module.scss';

const CheckboxPopup: React.FC<CustomFilterBodyProps> = observer(
  ({ childs, handleChange, category, item }) => {
    const { openCategoryChild } = filterStore;
    const [data, setData] = useState<any>([...childs]);

    return (
      <FloorPopup
        onCancel={() => {
          item.onCancel(category, item);
        }}
        onSelect={() => {
          item.onConfirm(data);
        }}
        isSingle={!!item?.isSingle}
      >
        <div className={styles.container}>
          {data?.map((child: any, i: number) => (
            <div key={i} className={styles.filterSectionSettingContainer}>
              {!item?.isSingle ? (
                <Checkbox
                  checked={child.selected}
                  onChanges={() => {
                    const res = data;
                    res[i] = {
                      ...res[i],
                      selected: !res[i].selected,
                    };
                    setData([...res]);
                  }}
                >
                  <p
                    className={cn(styles.filterSectionSetting, styles.category)}
                  >
                    {child.name}
                  </p>
                </Checkbox>
              ) : (
                <p
                  className={cn(styles.filterSectionSetting, styles.category, {
                    [styles.selected]: child.selected,
                  })}
                  onClick={() => {
                    const res = data.map((dataItem: any, index: number) => ({
                      ...dataItem,
                      selected: index === i ? !dataItem.selected : false,
                    }));
                    setData([...res]);
                    handleChange([...res]);
                    openCategoryChild(category, item);
                  }}
                >
                  {child.name}
                </p>
              )}
            </div>
          ))}
        </div>
      </FloorPopup>
    );
  },
);

export default CheckboxPopup;
